const rankings = [
  { rank: 1, name: '97视频', desc: '老牌平台，内容体系成熟，用户基础广泛，综合热度持续领先', hot: true },
  { rank: 2, name: '丝瓜视频', desc: '新晋热门，界面简洁体验好，年轻用户增长迅猛', hot: true },
  { rank: 3, name: '蓝莓视频', desc: '独家内容差异化明显，用户粘性高，讨论热度稳定上升', hot: false },
  { rank: 4, name: '91在线视频', desc: '访问稳定性受关注，近期更新节奏加快引发热议', hot: false },
  { rank: 5, name: '糖心视频', desc: '内容分类丰富，社区氛围活跃，口碑持续走高', hot: true },
  { rank: 6, name: '黑桃视频', desc: '定位清晰受众精准，近期功能更新获得好评', hot: false },
  { rank: 7, name: '新兴平台观察', desc: '多款新平台进入视野，后续将逐一纳入对比体系', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            平台热度榜单
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            基于用户讨论度与关注热度的在线视频平台动态排名
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 ${
                i < rankings.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-sm font-bold">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">
                    {item.name}
                  </h3>
                  {item.hot && (
                    <span className="flex items-center gap-0.5 text-[10px] text-primary-600 font-medium whitespace-nowrap">
                      <i className="ri-fire-line"></i>热门
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}